export enum EDlouheKratke {
    D = 'D',
    K = 'K',
    O = 'O'
}
